import { render, staticRenderFns } from "./leibnizSaysGame.html?vue&type=template&id=41c7eb27&scoped=true&external"
import script from "./leibnizSaysGame.js?vue&type=script&lang=js&external"
export * from "./leibnizSaysGame.js?vue&type=script&lang=js&external"
import style0 from "./leibnizSaysGame.css?vue&type=style&index=0&id=41c7eb27&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c7eb27",
  null
  
)

export default component.exports